import Fuse from 'fuse.js';
import { appsList } from 'components/layouts/breadcrumb/breadcrumbHelpers';

/**
 * searchProvider — nơi tập trung LOGIC SEARCH (tách riêng để custom/mở rộng sau).
 *
 * Hiện tại: tìm theo tên app/route trong siteMaps (Fuse.js).
 * Về sau bạn có thể bổ sung search record qua API NGAY TẠI FILE NÀY
 * (vd thêm searchRecords(query) gọi apiAxios) mà không phải sửa modal.
 */
const fuse = new Fuse(appsList, {
  keys: ['label', 'to'],
  threshold: 0.4,
  ignoreLocation: true
});

export const searchApps = (query, limit = 20) => {
  const q = (query || '').trim();
  if (!q) return [];
  return fuse
    .search(q)
    .slice(0, limit)
    .map(r => r.item);
};

export default searchApps;
